import PageFooterWrapper from '@common/components/PageFooter/PageFooterWrapper';
import Skeleton from '@common/components/Skeleton';

function PageFooterLoading() {
  return (
    <PageFooterWrapper>
      <Skeleton type="long-line" color="dark" />
    </PageFooterWrapper>
  );
}

export default PageFooterLoading;
